import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import da from '@/i18n/da'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { da },
    current: 'da',
  },
  icons: {
    iconfont: 'mdi', // default
    values: {
      user: 'mdi-account',
      client: 'mdi-human-handsdown',
      clients: 'mdi-human-handsdown', // plural!
      // clients: 'mdi-human-male-female',
    },
  },
  theme: {
    themes: {
      light: {
        /* @ts-ignore */
        primary: colors.blueGrey.lighten1,
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
      dark: {
        primary: colors.blue.lighten3,
      },
    },
  },
})
